import BaseAPI from './base.api';

export default class TirePatternAPI extends BaseAPI {
  getTirePatterns = async () => {
    const response = await this.API.get('tire-pattern');
    return response.data;
  };
}
